import React, { useEffect, useState } from 'react'
import toastify from '../../../helper/toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getUserProfile, updateProfileImage, updateUserProfile } from '../../../redux/features/auth/authSliceNew';
import avtar from '../../../assets/images/user.png';
import MobileBottomBar from '../MobileBottomBar';
const Profile = () => {
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.auth);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        gender: "",
        dob: "",
    })
    const [loading, setLoading] = useState(false);
    const [preview, setPreview] = useState(null)

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };
    
    const formatDate = (dob) => {
        if (!dob) return '';
        const [dd, mm, yyyy] = dob.split("-");
        if (dd.length === 2 && mm.length === 2 && yyyy.length === 4) {
            return `${yyyy}-${mm}-${dd}`;
        }
        return dob; // fallback
    };
    
    useEffect(() => {
        if (user) {
            setFormData({
                name: user.name || '',
                email: user.email || '',
                mobile: user.mobile || '',
                gender: user.gender || '',
                // dob: user.dob || '',
                dob: user.dob ? formatDate(user.dob) : '',

            });
            if (user.profile) {
                setPreview(user.profile)
            }
        }
    }, [user]);

    useEffect(() => {
        dispatch(getUserProfile());
    }, [dispatch]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            const result = await dispatch(updateUserProfile(formData));
            if (result.success) {
                toastify.success("Profile updated successfully");
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    const handleImageChange = async (event) => {
        const file = event.target.files[0];
        try {
            const result = await dispatch(updateProfileImage(file));
            if (result.success) {
                setPreview(user?.profile);
            }
        } catch (error) {
        }
    };
    return (
        <>
            <section className="innr-page-banner profile-page">
                <div className="container">
                    <div className="banner-content text-center">
                        <h1 className="text-white mb-3">My Profile</h1>
                        <p className="text-white-50 mb-0">Manage your personal information and preferences</p>
                    </div>
                </div>
            </section>
            
            <section className="profile-sec tp-space mb-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-10 col-sm-12">
                            <div className="profile-innr modern-profile">
                                <form onSubmit={handleSubmit}>
                                    {/* Profile Header Card */}
                                    <div className="profile-header-card">
                                        <div className="profile-avatar-section">
                                            <div className="profile-avatar-wrapper">
                                                <img 
                                                    src={preview ? preview : avtar} 
                                                    alt="Profile" 
                                                    className="profile-avatar"
                                                />
                                                                                                 <div className="avatar-overlay">
                                                     <input 
                                                         type="file" 
                                                         id="upload" 
                                                         accept='images/*'
                                                         onChange={handleImageChange}
                                                         className="avatar-file-input"
                                                     />
                                                     <label htmlFor="upload" className="avatar-upload-btn">
                                                         <i className="fas fa-camera" />
                                                         <span className="upload-text">Change Photo</span>
                                                     </label>
                                                 </div>
                                            </div>
                                            <div className="profile-info">
                                                <h3 className="profile-name">{formData.name || 'Your Name'}</h3>
                                                <p className="profile-email">{formData.email || 'email@example.com'}</p>
                                                <div className="profile-status">
                                                    <span className="status-badge">
                                                        <i className="fas fa-check-circle"></i>
                                                        Profile Active
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Profile Form Section */}
                                    <div className="profile-form-section">
                                        <div className="section-header">
                                            <h4 className="section-title">
                                                <i className="fas fa-user-edit"></i>
                                                Personal Information
                                            </h4>
                                            <p className="section-subtitle">Update your personal details below</p>
                                        </div>
                                        
                                        <div className="form-grid">
                                            <div className="form-group modern-form-group">
                                                <label htmlFor="name" className="form-label">
                                                    <i className="fas fa-user"></i>
                                                    Full Name
                                                </label>
                                                <div className="input-wrapper">
                                                    <input 
                                                        type="text" 
                                                        id="name"
                                                        className="form-control modern-input" 
                                                        placeholder="Enter your full name" 
                                                        name='name' 
                                                        value={formData.name} 
                                                        onChange={handleChange} 
                                                    />
                                                    <i className="fas fa-pencil input-icon" />
                                                </div>
                                            </div>

                                                                                         <div className="form-group modern-form-group">
                                                 <label htmlFor="mobile" className="form-label">
                                                     <i className="fas fa-mobile-alt"></i>
                                                     Mobile Number
                                                 </label>
                                                 <div className="input-wrapper">
                                                     <input 
                                                         type="number" 
                                                         id="mobile"
                                                         className="form-control modern-input" 
                                                         placeholder="Enter mobile number" 
                                                         name='mobile' 
                                                         value={formData.mobile} 
                                                         onChange={handleChange} 
                                                     />
                                                     <i className="fas fa-pencil input-icon" />
                                                 </div>
                                             </div>

                                                                                         <div className="form-group modern-form-group">
                                                 <label htmlFor="email" className="form-label">
                                                     <i className="fas fa-envelope"></i>
                                                     Email Address
                                                 </label>
                                                 <div className="input-wrapper">
                                                     <input
                                                         type="email"
                                                         id="email"
                                                         className="form-control modern-input"
                                                         placeholder="Enter email address"
                                                         name='email' 
                                                         value={formData.email} 
                                                         onChange={handleChange}
                                                     />
                                                     <i className="fas fa-envelope input-icon" />
                                                 </div>
                                             </div>

                                                                                         <div className="form-group modern-form-group">
                                                 <label htmlFor="gender" className="form-label">
                                                     <i className="fas fa-venus-mars"></i>
                                                     Gender
                                                 </label>
                                                 <div className="input-wrapper">
                                                     <select 
                                                         name='gender' 
                                                         id="gender"
                                                         value={formData.gender} 
                                                         onChange={handleChange} 
                                                         className="form-select modern-select"
                                                     >
                                                         <option value="">Select your gender</option>
                                                         <option value="male">Male</option>
                                                         <option value="female">Female</option>
                                                         <option value="other">Other</option>
                                                     </select>
                                                     <i className="fas fa-chevron-down input-icon" />
                                                 </div>
                                             </div>
                                        </div>

                                        <div className="form-actions">
                                            <button 
                                                className="thm-btn fill-btn update-btn" 
                                                disabled={loading} 
                                                type="submit"
                                            >
                                                {loading ? (
                                                    <>
                                                        <i className="fas fa-spinner fa-spin"></i>
                                                        Updating Profile...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fas fa-save"></i>
                                                        Update Profile
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mobile Bottom Bar */}
            <MobileBottomBar />
        </>
    )
}

export default Profile